import { render, staticRenderFns } from "./customFields.vue?vue&type=template&id=23e3ea24&scoped=true"
import script from "./customFields.vue?vue&type=script&lang=js"
export * from "./customFields.vue?vue&type=script&lang=js"
import style0 from "./customFields.vue?vue&type=style&index=0&id=23e3ea24&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "23e3ea24",
  null
  
)

export default component.exports